namespace GeniuzPOS.PosShift {
    export interface PsPosMoneyCountRow {
        Id?: number;
        CountId?: number;
        CashierId?: string;
        PosId?: string;
        ShopId?: string;
        CountDate?: string;
        InTime?: string;
        CountType?: number;
        TypeCb?: number;
        TenderType?: number;
        TenderCode?: string;
        TenderName?: string;
        TenderRate?: number;
        TenderQty?: number;
        TenderAmt?: number;
        Remark?: string;
        BagCode?: string;
        CreateBy?: string;
        CreateDate?: string;
        UpdateBy?: string;
        LastUpdate?: string;
        CusWsFlg?: number;
    }

    export namespace PsPosMoneyCountRow {
        export const idProperty = 'Id';
        export const nameProperty = 'CashierId';
        export const localTextPrefix = 'PosShift.PsPosMoneyCount';
        export const deletePermission = 'Administration:General';
        export const insertPermission = 'Administration:General';
        export const readPermission = 'Administration:General';
        export const updatePermission = 'Administration:General';

        export declare const enum Fields {
            Id = "Id",
            CountId = "CountId",
            CashierId = "CashierId",
            PosId = "PosId",
            ShopId = "ShopId",
            CountDate = "CountDate",
            InTime = "InTime",
            CountType = "CountType",
            TypeCb = "TypeCb",
            TenderType = "TenderType",
            TenderCode = "TenderCode",
            TenderName = "TenderName",
            TenderRate = "TenderRate",
            TenderQty = "TenderQty",
            TenderAmt = "TenderAmt",
            Remark = "Remark",
            BagCode = "BagCode",
            CreateBy = "CreateBy",
            CreateDate = "CreateDate",
            UpdateBy = "UpdateBy",
            LastUpdate = "LastUpdate",
            CusWsFlg = "CusWsFlg"
        }
    }
}
